export class NutritionOrder {
  id = null;
  name = null;
  code = null;
  type = null;
}
